module.exports = __webpack_public_path__ + "img/icon-num4.b75aae24.png";